import React from "react";

import { Search } from "@material-ui/icons";
import { TextField, makeStyles } from "@material-ui/core";
import Autocomplete, {
  AutocompleteRenderInputParams,
} from "@material-ui/lab/Autocomplete";
import InputAdornment from "@material-ui/core/InputAdornment";

import { getAreaAvatarColor } from "@ds-developer/frontend";
import AvataredAutocompleteOption from "@ds-developer/avatared-autocomplete-option";

import { Region } from "@hubcapp/types";

import {
  AreaPostcodeSearchOptionProps,
  AreaPostcodeSearchProps,
} from "./types";

const AreaPostcodeSearchOption = ({
  region,
}: AreaPostcodeSearchOptionProps) => (
  <AvataredAutocompleteOption
    optionLabel={region.regionName}
    avatarLabel={region.regionCode}
    avatarColour={getAreaAvatarColor(region.regionName)}
  />
);

const useStyles = makeStyles(theme => ({
  root: {
    padding: 0,
  },
  option: {
    padding: theme.spacing(2, 0),
  },
}));
const AreaPostcodeSearch: React.FC<AreaPostcodeSearchProps> = ({
  onInputChange,
  onRegionSelected,
  areaData,
  onInputClick,
}) => {
  const classes = useStyles();

  const onKeyDownPress = (event: React.KeyboardEvent) => {
    if (event.key === "Enter" && !areaData.length) {
      event.preventDefault();
      event.stopPropagation();
      return false;
    }
  };

  const acRenderInput = (params: AutocompleteRenderInputParams) => (
    <TextField
      {...params}
      data-test="postcode-input"
      label="Start entering a postcode..."
      variant="outlined"
      id="postcode-input"
      onKeyDown={onKeyDownPress}
      onClick={onInputClick}
      InputProps={{
        ...params.InputProps,
        startAdornment: (
          <InputAdornment position="start">
            <Search />
          </InputAdornment>
        ),
      }}
    />
  );

  return (
    <React.Fragment>
      <Autocomplete<Region, false, false, true>
        className={classes.option}
        data-test="postcode-search"
        autoHighlight
        id="postcode-search"
        onChange={(event, value) => onRegionSelected(value as Region)}
        onInputChange={(event, text) => onInputChange(text)}
        freeSolo
        handleHomeEndKeys
        renderOption={(option: Region) => (
          <AreaPostcodeSearchOption region={option} />
        )}
        getOptionLabel={(option: Region) => option.regionName}
        options={areaData}
        disabled={!onInputChange}
        filterOptions={x => x}
        renderInput={params => acRenderInput(params)}
      />
    </React.Fragment>
  );
};
export default AreaPostcodeSearch;
